/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import clsx from "clsx"

import type { ApplicationType } from "../../features/application-type/application-type-types"
import { valueOrDash } from "../../utils/value-or-dash"
import { AppIcon } from "../components/app-icon"
import { CategoryPlatform } from "../components/category-platform"

import "./sidebar-offcanvas-item-view.css"

const Asset = {
    FavoriteOn: "/assets/ic-star-fill.svg",
    FavoriteOff: "/assets/ic-star.svg"
} as const

interface Props {
    appType: ApplicationType
    isFavorite: boolean
    onFavoriteChange: () => void
    isEnabled: boolean
    onEnabledChange: () => void
}

export const SidebarOffcanvasItemView = ({
    appType,
    isEnabled,
    isFavorite,
    onEnabledChange,
    onFavoriteChange
}: Props) => {
    const favoriteLabel = isFavorite ? "Remove from favorites" : "Add to favorites"

    return (
        <li
            className={clsx("sidebar-offcanvas-item-view list-group-item", {
                "is-disabled": !isEnabled
            })}
        >
            <div className="item-dot" />
            <AppIcon appTypeId={appType.id} className="item-icon" />
            <button
                type="button"
                className="item-button"
                role="switch"
                aria-checked={isEnabled}
                onClick={onEnabledChange}
            >
                <strong className="item-title truncate">{valueOrDash(appType.description)}</strong>
                <span className="item-description truncate">{appType.sourcePackageName}</span>
            </button>
            <CategoryPlatform category={appType.category} platform={appType.platform} />
            <button
                type="button"
                className="item-toggle"
                aria-label={favoriteLabel}
                title={favoriteLabel}
                onClick={onFavoriteChange}
            >
                <img src={isFavorite ? Asset.FavoriteOn : Asset.FavoriteOff} alt="" />
            </button>
        </li>
    )
}
